import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

// List of extracted text snippets with per-snippet selection checkboxes.
const TextSnippetsList = ({
  textSnippets,
  selectedTexts,
  allTextsSelected,
  onToggleSelectedText,
  onToggleSelectAllTexts,
}) => (
  <div className="mb-4 border border-hairline rounded-lg">
    <div className="p-3 border-b border-hairline flex items-center justify-between">
      <div className="text-sm font-semibold text-ink">Relevant Text Snippets ({textSnippets.length})</div>
      <button type="button" onClick={onToggleSelectAllTexts} disabled={textSnippets.length === 0} className="text-sm text-accent disabled:text-muted inline-flex items-center gap-1">
        {allTextsSelected ? <CheckSquare size={14} /> : <Square size={14} />}
        {allTextsSelected ? 'Deselect all' : 'Select all'}
      </button>
    </div>
    <div className="max-h-[260px] overflow-auto p-2 space-y-2">
      {textSnippets.length === 0 ? (
        <div className="text-sm text-muted p-2">No text snippets extracted.</div>
      ) : textSnippets.map((row, index) => (
        <label key={`${row.text}-${index}`} className="flex items-start gap-2 p-2 hover:bg-surface-2 rounded cursor-pointer">
          <input
            type="checkbox"
            checked={selectedTexts.includes(row.text)}
            onChange={() => onToggleSelectedText(row.text)}
            className="mt-1"
          />
          <div className="min-w-0">
            <div className="text-sm text-ink">{row.text}</div>
            <div className={`text-[11px] ${row.selected !== false ? 'text-positive' : 'text-warn'} truncate`}>
              {row.selection_reason || (row.selected !== false ? 'selected' : 'deselected')}
            </div>
          </div>
        </label>
      ))}
    </div>
  </div>
);

export default TextSnippetsList;
